/**
 * Copy aligned with SPE `ProductOptionsSection` / `AdditionalInformationSection` and
 * wizard `SpeWizardModal` AI strings. Prototype-only — not localized.
 */
export const INLINE_SPE_COPY = {
  aiFieldTooltip: "Suggested by AI",
  aiOptionsTooltip: "Options detected by AI",
  regenerate: "Regenerate",
  regenerateOptionsFromImages: "Regenerate from images",
  generatingSuggestion: "Generating suggestion...",
  generatingVariants: "Generating variant suggestions...",
  aiError: "AI suggestion unavailable. Type manually or try again.",
  retry: "Retry",
  imagesHeading: "Images",
  imagesSubheading:
    "Ensure your images have a neutral background, are cropped to fill the square, and include all product options. Images must be at least 600 x 600 pixels. Review guidelines",
  uploadFeaturedLabel: "Upload featured image",
  uploadFeaturedFormats: "Supported files .png, .jpg, .webp",
  uploadFeaturedMinSize: "Minimum 600 x 600 pixels",
  imagesUploadHint: "Drag and drop, paste, or browse to upload images",
  imagesPastePlaceholder: "Press ⌘V to paste an image or image URL",
  basicHeading: "Basic information",
  basicSubheading:
    "Add a name and description for your product. These details help buyers find what they're looking for.",
  titleLabel: "Product title",
  descriptionLabel: "Description",
  titlePlaceholder: "Enter a clear product title",
  descriptionPlaceholder:
    "Describe materials, dimensions, and what makes it special",
  optionsHeading: "Product options",
  optionsSubheading:
    "Manage any variations of this product—like sizes, colors, or the language of your packaging.",
  radioHasOptions: "This product has options",
  radioNoOptions: "This product doesn't have options",
  editProductOptions: "Edit product options",
  optionsDetectedLead: "Automatically detected options:",
  optionsDetectedNames: "Color, Size",
  columnPhoto: "Photo",
  columnSwatch: "Swatch",
  columnName: "Name",
  columnSku: "SKU",
  columnWholesaleUs: "Wholesale (US)",
  columnRetailUs: "Retail (US)",
  columnMarginUs: "Margin (US)",
  columnOnHand: "On hand",
  columnAvailable: "Available",
  skuPlaceholder: "SKU",
  marginEmpty: "—",
  photoCellAriaLabel: "Add or edit variant photo",
  availableAriaLabel: "Available units",
} as const;

export const AI_FIELD_DELAY_MS = 1400;
export const OPTIONS_LOAD_MS = 1200;

/** Prefilled when Flare finishes variant detection (mock). */
export const MOCK_VARIANT_PREFILL = {
  wholesale: "24.00",
  retail: "48.00",
  onHand: "10",
} as const;

export const MOCK_IMAGE_URLS = [
  "https://cdn.prerelease.faire.dev/fastly/2af42ea4c9201a98c9881266a32f72f16b4bdbd8c6ca3afeda070dfcec374494.jpeg",
  "https://cdn.prerelease.faire.dev/fastly/8d250e699b908e9198f233fb52ee9c35d62154b8bebcb2a294201285d5861e13.jpeg",
  "https://cdn.prerelease.faire.dev/fastly/2aeb9dc918056675804503d6ec31dd7a4682c4bea51dafeeb7350d44536ddc1c.jpeg",
] as const;
